export default "__VITE_ASSET__0a25687d__"